/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1756
 */

module.exports = function (e, t) {
  for (var n = 0, /* [auto-meaningful-name] */t$length = t.length, o = new e(t$length); t$length > n;) {
    o[n] = t[n++]
  }
  return o
}
